export default __webpack_public_path__ + "assets/images/7883decd46746147788af3831f7bd094.png";